<template>
  <div
    class="flex h-[63px] w-[65px] items-center justify-center rounded-full bg-neutral-800 px-spacing_3 py-spacing_4 text-size_8 font-extrabold leading-8 text-action_text"
  >
    {{ avatarInitials }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  avatar: {
    type: String,
    required: true,
  },
});

const avatarInitials = computed(() => {
  if (!props.avatar) return "";

  const words = props.avatar.trim().split(" ");
  const firstInitial = words[0]?.charAt(0).toUpperCase() || "";
  const secondInitial = words[1]?.charAt(0).toUpperCase() || "";

  return firstInitial + secondInitial;
});
</script>
